var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _g, _g2, _path501, _g3, _g4, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1920 1158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#040406",
    d: "M0 0h1920v1158H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__a)",
    fillOpacity: 0.4,
    d: "M0 0h1920v1158H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__b)",
    fillOpacity: 0.4,
    d: "M0 0h1920v1158H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__c)",
    fillOpacity: 0.02,
    d: "M533.672 352.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__d)",
    fillOpacity: 0.12,
    d: "M533.672 352.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__e)",
    fillOpacity: 0.02,
    d: "M575.82 352.101v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__f)",
    fillOpacity: 0.12,
    d: "M575.82 352.101v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__g)",
    fillOpacity: 0.02,
    d: "M386.32 388.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__h)",
    fillOpacity: 0.12,
    d: "M386.32 388.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__i)",
    fillOpacity: 0.02,
    d: "M470.609 388.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__j)",
    fillOpacity: 0.12,
    d: "M470.609 388.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__k)",
    fillOpacity: 0.02,
    d: "M512.781 388.175v22.6l19.775 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__l)",
    fillOpacity: 0.12,
    d: "M512.781 388.175v22.6l19.775 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__m)",
    fillOpacity: 0.02,
    d: "M681.391 388.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__n)",
    fillOpacity: 0.12,
    d: "M681.391 388.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__o)",
    fillOpacity: 0.02,
    d: "M322.891 424.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__p)",
    fillOpacity: 0.12,
    d: "M322.891 424.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__q)",
    fillOpacity: 0.02,
    d: "M533.672 424.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__r)",
    fillOpacity: 0.12,
    d: "M533.672 424.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__s)",
    fillOpacity: 0.02,
    d: "M617.961 424.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__t)",
    fillOpacity: 0.12,
    d: "M617.961 424.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__u)",
    fillOpacity: 0.02,
    d: "M470.609 459.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__v)",
    fillOpacity: 0.12,
    d: "M470.609 459.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__w)",
    fillOpacity: 0.02,
    d: "M639.25 459.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__x)",
    fillOpacity: 0.12,
    d: "M639.25 459.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__y)",
    fillOpacity: 0.02,
    d: "M681.391 459.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__z)",
    fillOpacity: 0.12,
    d: "M681.391 459.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__A)",
    fillOpacity: 0.02,
    d: "M449.781 280.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__B)",
    fillOpacity: 0.12,
    d: "M449.781 280.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__C)",
    fillOpacity: 0.02,
    d: "M576.25 280.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__D)",
    fillOpacity: 0.12,
    d: "M576.25 280.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__E)",
    fillOpacity: 0.02,
    d: "M449.422 496.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__F)",
    fillOpacity: 0.12,
    d: "M449.422 496.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__G)",
    fillOpacity: 0.02,
    d: "M575.875 496.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__H)",
    fillOpacity: 0.12,
    d: "M575.875 496.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__I)",
    fillOpacity: 0.06,
    d: "M386.32 316.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__J)",
    fillOpacity: 0.06,
    d: "M428.461 316.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__K)",
    fillOpacity: 0.06,
    d: "M470.609 316.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__L)",
    fillOpacity: 0.06,
    d: "M365.031 352.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__M)",
    fillOpacity: 0.06,
    d: "M491.5 352.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__N)",
    fillOpacity: 0.06,
    d: "M617.961 352.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__O)",
    fillOpacity: 0.06,
    d: "M660.14 352.101v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__P)",
    fillOpacity: 0.06,
    d: "M554.929 388.175v22.6l19.775 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__Q)",
    fillOpacity: 0.06,
    d: "M597.07 388.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__R)",
    fillOpacity: 0.06,
    d: "M639.25 388.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__S)",
    fillOpacity: 0.06,
    d: "M428.828 244.3v22.6l19.775 11.301 19.775-11.301v-22.6L448.603 233z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__T)",
    fillOpacity: 0.06,
    d: "M470.968 244.3v22.6l19.776 11.301 19.775-11.301v-22.6L490.744 233z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__U)",
    fillOpacity: 0.06,
    d: "M513.148 244.3v22.6l19.775 11.301 19.775-11.301v-22.6L532.923 233z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__V)",
    fillOpacity: 0.06,
    d: "M386.32 459.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__W)",
    fillOpacity: 0.06,
    d: "M428.461 459.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__X)",
    fillOpacity: 0.06,
    d: "M512.781 459.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__Y)",
    fillOpacity: 0.06,
    d: "M365.484 280.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__Z)",
    fillOpacity: 0.06,
    d: "M407.632 280.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aa)",
    fillOpacity: 0.06,
    d: "M534.101 280.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ab)",
    fillOpacity: 0.06,
    d: "M533.734 496.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ac)",
    fillOpacity: 0.06,
    d: "M618.031 496.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ad)",
    fillOpacity: 0.06,
    d: "M660.195 496.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ae)",
    fillOpacity: 0.06,
    d: "M344.18 531.6v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__af)",
    fillOpacity: 0.06,
    d: "M386.321 531.6v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ag)",
    fillOpacity: 0.03,
    d: "M302 316.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ah)",
    fillOpacity: 0.06,
    d: "M302 316.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ai)",
    fillOpacity: 0.03,
    d: "M344.141 316.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aj)",
    fillOpacity: 0.06,
    d: "M344.141 316.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ak)",
    fillOpacity: 0.03,
    d: "M512.781 316.464v22.6l19.775 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__al)",
    fillOpacity: 0.06,
    d: "M512.781 316.464v22.6l19.775 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__am)",
    fillOpacity: 0.03,
    d: "M554.93 316.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__an)",
    fillOpacity: 0.06,
    d: "M554.93 316.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ao)",
    fillOpacity: 0.03,
    d: "M597.07 316.464v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ap)",
    fillOpacity: 0.06,
    d: "M597.07 316.464v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aq)",
    fillOpacity: 0.03,
    d: "M639.25 316.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ar)",
    fillOpacity: 0.06,
    d: "M639.25 316.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__as)",
    fillOpacity: 0.03,
    d: "M681.391 316.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__at)",
    fillOpacity: 0.06,
    d: "M681.391 316.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__au)",
    fillOpacity: 0.03,
    d: "M322.891 352.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__av)",
    fillOpacity: 0.06,
    d: "M322.891 352.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aw)",
    fillOpacity: 0.03,
    d: "M407.203 352.101v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ax)",
    fillOpacity: 0.06,
    d: "M407.203 352.101v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ay)",
    fillOpacity: 0.03,
    d: "M449.352 352.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__az)",
    fillOpacity: 0.06,
    d: "M449.352 352.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aA)",
    fillOpacity: 0.03,
    d: "M302 388.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aB)",
    fillOpacity: 0.06,
    d: "M302 388.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aC)",
    fillOpacity: 0.03,
    d: "M344.141 388.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aD)",
    fillOpacity: 0.06,
    d: "M344.141 388.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aE)",
    fillOpacity: 0.03,
    d: "M365.031 424.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aF)",
    fillOpacity: 0.06,
    d: "M365.031 424.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aG)",
    fillOpacity: 0.03,
    d: "M407.203 424.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aH)",
    fillOpacity: 0.06,
    d: "M407.203 424.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aI)",
    fillOpacity: 0.03,
    d: "M449.352 424.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aJ)",
    fillOpacity: 0.06,
    d: "M449.352 424.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aK)",
    fillOpacity: 0.03,
    d: "M491.5 424.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aL)",
    fillOpacity: 0.06,
    d: "M491.5 424.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aM)",
    fillOpacity: 0.03,
    d: "M575.82 424.197v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aN)",
    fillOpacity: 0.06,
    d: "M575.82 424.197v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aO)",
    fillOpacity: 0.03,
    d: "M660.141 424.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aP)",
    fillOpacity: 0.06,
    d: "M660.141 424.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aQ)",
    fillOpacity: 0.03,
    d: "M344.516 244.3v22.6l19.775 11.301 19.775-11.301v-22.6L364.291 233z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aR)",
    fillOpacity: 0.06,
    d: "M344.516 244.3v22.6l19.775 11.301 19.775-11.301v-22.6L364.291 233z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aS)",
    fillOpacity: 0.03,
    d: "M386.68 244.3v22.6l19.775 11.301L426.23 266.9v-22.6L406.455 233z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aT)",
    fillOpacity: 0.06,
    d: "M386.68 244.3v22.6l19.775 11.301L426.23 266.9v-22.6L406.455 233z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aU)",
    fillOpacity: 0.03,
    d: "M555.289 244.3v22.6l19.775 11.301L594.84 266.9v-22.6L575.064 233z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aV)",
    fillOpacity: 0.06,
    d: "M555.289 244.3v22.6l19.775 11.301L594.84 266.9v-22.6L575.064 233z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aW)",
    fillOpacity: 0.03,
    d: "M597.438 244.3v22.6l19.775 11.301 19.775-11.301v-22.6L617.213 233z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aX)",
    fillOpacity: 0.06,
    d: "M597.438 244.3v22.6l19.775 11.301 19.775-11.301v-22.6L617.213 233z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aY)",
    fillOpacity: 0.03,
    d: "M639.609 244.3v22.6l19.776 11.301L679.16 266.9v-22.6L659.385 233z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__aZ)",
    fillOpacity: 0.06,
    d: "M639.609 244.3v22.6l19.776 11.301L679.16 266.9v-22.6L659.385 233z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ba)",
    fillOpacity: 0.03,
    d: "M302 459.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bb)",
    fillOpacity: 0.06,
    d: "M302 459.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bc)",
    fillOpacity: 0.03,
    d: "M344.141 459.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bd)",
    fillOpacity: 0.06,
    d: "M344.141 459.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__be)",
    fillOpacity: 0.03,
    d: "M554.93 459.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bf)",
    fillOpacity: 0.06,
    d: "M554.93 459.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bg)",
    fillOpacity: 0.03,
    d: "M597.07 459.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bh)",
    fillOpacity: 0.06,
    d: "M597.07 459.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bi)",
    fillOpacity: 0.03,
    d: "M323.32 280.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bj)",
    fillOpacity: 0.06,
    d: "M323.32 280.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bk)",
    fillOpacity: 0.03,
    d: "M491.953 280.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bl)",
    fillOpacity: 0.06,
    d: "M491.953 280.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bm)",
    fillOpacity: 0.03,
    d: "M618.391 280.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bn)",
    fillOpacity: 0.06,
    d: "M618.391 280.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bo)",
    fillOpacity: 0.03,
    d: "M660.57 280.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bp)",
    fillOpacity: 0.06,
    d: "M660.57 280.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bq)",
    fillOpacity: 0.03,
    d: "M322.953 496.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__br)",
    fillOpacity: 0.06,
    d: "M322.953 496.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bs)",
    fillOpacity: 0.03,
    d: "M365.117 496.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bt)",
    fillOpacity: 0.06,
    d: "M365.117 496.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bu)",
    fillOpacity: 0.03,
    d: "M407.266 496.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bv)",
    fillOpacity: 0.06,
    d: "M407.266 496.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bw)",
    fillOpacity: 0.03,
    d: "M491.578 496.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bx)",
    fillOpacity: 0.06,
    d: "M491.578 496.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__by)",
    fillOpacity: 0.03,
    d: "M428.461 388.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bz)",
    fillOpacity: 0.06,
    d: "M428.461 388.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bA)",
    fillOpacity: 0.02,
    d: "M992.672 144.101v22.6l19.778 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bB)",
    fillOpacity: 0.12,
    d: "M992.672 144.101v22.6l19.778 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bC)",
    fillOpacity: 0.02,
    d: "M1034.82 144.101v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bD)",
    fillOpacity: 0.12,
    d: "M1034.82 144.101v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bE)",
    fillOpacity: 0.02,
    d: "M845.32 180.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bF)",
    fillOpacity: 0.12,
    d: "M845.32 180.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bG)",
    fillOpacity: 0.02,
    d: "M929.609 180.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bH)",
    fillOpacity: 0.12,
    d: "M929.609 180.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bI)",
    fillOpacity: 0.02,
    d: "M971.781 180.175v22.6l19.775 11.301 19.774-11.301v-22.6l-19.774-11.3z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bJ)",
    fillOpacity: 0.12,
    d: "M971.781 180.175v22.6l19.775 11.301 19.774-11.301v-22.6l-19.774-11.3z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bK)",
    fillOpacity: 0.02,
    d: "M1140.39 180.175v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bL)",
    fillOpacity: 0.12,
    d: "M1140.39 180.175v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bM)",
    fillOpacity: 0.02,
    d: "M781.891 216.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bN)",
    fillOpacity: 0.12,
    d: "M781.891 216.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bO)",
    fillOpacity: 0.02,
    d: "M992.672 216.197v22.6l19.778 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bP)",
    fillOpacity: 0.12,
    d: "M992.672 216.197v22.6l19.778 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bQ)",
    fillOpacity: 0.02,
    d: "M1076.96 216.197v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bR)",
    fillOpacity: 0.12,
    d: "M1076.96 216.197v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bS)",
    fillOpacity: 0.02,
    d: "M929.609 251.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bT)",
    fillOpacity: 0.12,
    d: "M929.609 251.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bU)",
    fillOpacity: 0.02,
    d: "M1098.25 251.972v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bV)",
    fillOpacity: 0.12,
    d: "M1098.25 251.972v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bW)",
    fillOpacity: 0.02,
    d: "M1140.39 251.972v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bX)",
    fillOpacity: 0.12,
    d: "M1140.39 251.972v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bY)",
    fillOpacity: 0.02,
    d: "M908.781 72.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__bZ)",
    fillOpacity: 0.12,
    d: "M908.781 72.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ca)",
    fillOpacity: 0.02,
    d: "M1035.25 72.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cb)",
    fillOpacity: 0.12,
    d: "M1035.25 72.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cc)",
    fillOpacity: 0.02,
    d: "M908.422 288.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cd)",
    fillOpacity: 0.12,
    d: "M908.422 288.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ce)",
    fillOpacity: 0.02,
    d: "M1034.88 288.247v22.601l19.77 11.3 19.78-11.3v-22.601l-19.78-11.3z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cf)",
    fillOpacity: 0.12,
    d: "M1034.88 288.247v22.601l19.77 11.3 19.78-11.3v-22.601l-19.78-11.3z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cg)",
    fillOpacity: 0.06,
    d: "M845.32 108.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ch)",
    fillOpacity: 0.06,
    d: "M887.461 108.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ci)",
    fillOpacity: 0.06,
    d: "M929.609 108.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cj)",
    fillOpacity: 0.06,
    d: "M824.031 144.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ck)",
    fillOpacity: 0.06,
    d: "M950.5 144.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cl)",
    fillOpacity: 0.06,
    d: "M1076.96 144.101v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cm)",
    fillOpacity: 0.06,
    d: "M1119.14 144.101v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cn)",
    fillOpacity: 0.06,
    d: "M1013.93 180.175v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__co)",
    fillOpacity: 0.06,
    d: "M1056.07 180.175v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cp)",
    fillOpacity: 0.06,
    d: "M1098.25 180.175v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cq)",
    fillOpacity: 0.06,
    d: "M887.828 36.3v22.6l19.775 11.3 19.775-11.3V36.3L907.603 25z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cr)",
    fillOpacity: 0.06,
    d: "M929.968 36.3v22.6l19.776 11.3 19.775-11.3V36.3L949.744 25z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cs)",
    fillOpacity: 0.06,
    d: "M972.148 36.3v22.6l19.775 11.3 19.777-11.3V36.3L991.923 25z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ct)",
    fillOpacity: 0.06,
    d: "M845.32 251.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cu)",
    fillOpacity: 0.06,
    d: "M887.461 251.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cv)",
    fillOpacity: 0.06,
    d: "M971.781 251.972v22.6l19.775 11.3 19.774-11.3v-22.6l-19.774-11.3z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cw)",
    fillOpacity: 0.06,
    d: "M824.484 72.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cx)",
    fillOpacity: 0.06,
    d: "M866.632 72.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cy)",
    fillOpacity: 0.06,
    d: "M993.101 72.576v22.6l19.779 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cz)",
    fillOpacity: 0.06,
    d: "M992.734 288.247v22.601l19.776 11.3 19.77-11.3v-22.601l-19.77-11.3z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cA)",
    fillOpacity: 0.06,
    d: "M1077.03 288.247v22.601l19.78 11.3 19.77-11.3v-22.601l-19.77-11.3z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cB)",
    fillOpacity: 0.06,
    d: "M1119.19 288.247v22.601l19.78 11.3 19.78-11.3v-22.601l-19.78-11.3z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cC)",
    fillOpacity: 0.06,
    d: "M803.18 323.6v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cD)",
    fillOpacity: 0.06,
    d: "M845.321 323.6v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cE)",
    fillOpacity: 0.04,
    d: "M761 108.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cF)",
    fillOpacity: 0.06,
    d: "M761 108.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cG)",
    fillOpacity: 0.04,
    d: "M803.141 108.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cH)",
    fillOpacity: 0.06,
    d: "M803.141 108.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cI)",
    fillOpacity: 0.04,
    d: "M971.781 108.464v22.6l19.775 11.301 19.774-11.301v-22.6l-19.774-11.3z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cJ)",
    fillOpacity: 0.06,
    d: "M971.781 108.464v22.6l19.775 11.301 19.774-11.301v-22.6l-19.774-11.3z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cK)",
    fillOpacity: 0.04,
    d: "M1013.93 108.464v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cL)",
    fillOpacity: 0.06,
    d: "M1013.93 108.464v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cM)",
    fillOpacity: 0.04,
    d: "M1056.07 108.464v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cN)",
    fillOpacity: 0.06,
    d: "M1056.07 108.464v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cO)",
    fillOpacity: 0.04,
    d: "M1098.25 108.464v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cP)",
    fillOpacity: 0.06,
    d: "M1098.25 108.464v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cQ)",
    fillOpacity: 0.04,
    d: "M1140.39 108.464v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cR)",
    fillOpacity: 0.06,
    d: "M1140.39 108.464v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cS)",
    fillOpacity: 0.04,
    d: "M781.891 144.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cT)",
    fillOpacity: 0.06,
    d: "M781.891 144.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cU)",
    fillOpacity: 0.04,
    d: "M866.203 144.101v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cV)",
    fillOpacity: 0.06,
    d: "M866.203 144.101v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cW)",
    fillOpacity: 0.04,
    d: "M908.352 144.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cX)",
    fillOpacity: 0.06,
    d: "M908.352 144.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cY)",
    fillOpacity: 0.04,
    d: "M761 180.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__cZ)",
    fillOpacity: 0.06,
    d: "M761 180.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__da)",
    fillOpacity: 0.04,
    d: "M803.141 180.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__db)",
    fillOpacity: 0.06,
    d: "M803.141 180.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dc)",
    fillOpacity: 0.04,
    d: "M824.031 216.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dd)",
    fillOpacity: 0.06,
    d: "M824.031 216.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__de)",
    fillOpacity: 0.04,
    d: "M866.203 216.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__df)",
    fillOpacity: 0.06,
    d: "M866.203 216.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dg)",
    fillOpacity: 0.04,
    d: "M908.352 216.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dh)",
    fillOpacity: 0.06,
    d: "M908.352 216.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__di)",
    fillOpacity: 0.04,
    d: "M950.5 216.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dj)",
    fillOpacity: 0.06,
    d: "M950.5 216.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dk)",
    fillOpacity: 0.04,
    d: "M1034.82 216.197v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dl)",
    fillOpacity: 0.06,
    d: "M1034.82 216.197v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dm)",
    fillOpacity: 0.04,
    d: "M1119.14 216.197v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dn)",
    fillOpacity: 0.06,
    d: "M1119.14 216.197v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__do)",
    fillOpacity: 0.04,
    d: "M803.516 36.3v22.6l19.775 11.3 19.775-11.3V36.3L823.291 25z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dp)",
    fillOpacity: 0.06,
    d: "M803.516 36.3v22.6l19.775 11.3 19.775-11.3V36.3L823.291 25z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dq)",
    fillOpacity: 0.04,
    d: "M845.68 36.3v22.6l19.775 11.3 19.775-11.3V36.3L865.455 25z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dr)",
    fillOpacity: 0.06,
    d: "M845.68 36.3v22.6l19.775 11.3 19.775-11.3V36.3L865.455 25z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ds)",
    fillOpacity: 0.04,
    d: "M1014.29 36.3v22.6l19.77 11.3 19.78-11.3V36.3L1034.06 25z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dt)",
    fillOpacity: 0.06,
    d: "M1014.29 36.3v22.6l19.77 11.3 19.78-11.3V36.3L1034.06 25z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__du)",
    fillOpacity: 0.04,
    d: "M1056.44 36.3v22.6l19.77 11.3 19.78-11.3V36.3L1076.21 25z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dv)",
    fillOpacity: 0.06,
    d: "M1056.44 36.3v22.6l19.77 11.3 19.78-11.3V36.3L1076.21 25z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dw)",
    fillOpacity: 0.04,
    d: "M1098.61 36.3v22.6l19.77 11.3 19.78-11.3V36.3L1118.38 25z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dx)",
    fillOpacity: 0.06,
    d: "M1098.61 36.3v22.6l19.77 11.3 19.78-11.3V36.3L1118.38 25z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dy)",
    fillOpacity: 0.04,
    d: "M761 251.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dz)",
    fillOpacity: 0.06,
    d: "M761 251.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dA)",
    fillOpacity: 0.04,
    d: "M803.141 251.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dB)",
    fillOpacity: 0.06,
    d: "M803.141 251.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dC)",
    fillOpacity: 0.04,
    d: "M1013.93 251.972v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dD)",
    fillOpacity: 0.06,
    d: "M1013.93 251.972v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dE)",
    fillOpacity: 0.04,
    d: "M1056.07 251.972v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dF)",
    fillOpacity: 0.06,
    d: "M1056.07 251.972v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dG)",
    fillOpacity: 0.04,
    d: "M782.32 72.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dH)",
    fillOpacity: 0.06,
    d: "M782.32 72.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dI)",
    fillOpacity: 0.04,
    d: "M950.953 72.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dJ)",
    fillOpacity: 0.06,
    d: "M950.953 72.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dK)",
    fillOpacity: 0.04,
    d: "M1077.39 72.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dL)",
    fillOpacity: 0.06,
    d: "M1077.39 72.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dM)",
    fillOpacity: 0.04,
    d: "M1119.57 72.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dN)",
    fillOpacity: 0.06,
    d: "M1119.57 72.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dO)",
    fillOpacity: 0.04,
    d: "M781.953 288.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dP)",
    fillOpacity: 0.06,
    d: "M781.953 288.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dQ)",
    fillOpacity: 0.04,
    d: "M824.117 288.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dR)",
    fillOpacity: 0.06,
    d: "M824.117 288.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dS)",
    fillOpacity: 0.04,
    d: "M866.266 288.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dT)",
    fillOpacity: 0.06,
    d: "M866.266 288.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dU)",
    fillOpacity: 0.04,
    d: "M950.578 288.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dV)",
    fillOpacity: 0.06,
    d: "M950.578 288.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dW)",
    fillOpacity: 0.04,
    d: "M887.461 180.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dX)",
    fillOpacity: 0.06,
    d: "M887.461 180.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dY)",
    fillOpacity: 0.12,
    d: "M1292.27 527.399v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__dZ)",
    fillOpacity: 0.06,
    d: "M1292.27 527.399v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ea)",
    fillOpacity: 0.12,
    d: "M1250.12 527.399v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eb)",
    fillOpacity: 0.06,
    d: "M1250.12 527.399v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ec)",
    fillOpacity: 0.12,
    d: "M1439.62 491.325v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ed)",
    fillOpacity: 0.06,
    d: "M1439.62 491.325v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ee)",
    fillOpacity: 0.12,
    d: "M1355.33 491.325v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ef)",
    fillOpacity: 0.06,
    d: "M1355.33 491.325v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eg)",
    fillOpacity: 0.12,
    d: "M1313.16 491.325v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eh)",
    fillOpacity: 0.06,
    d: "M1313.16 491.325v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ei)",
    fillOpacity: 0.12,
    d: "M1144.55 491.325v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ej)",
    fillOpacity: 0.06,
    d: "M1144.55 491.325v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ek)",
    fillOpacity: 0.12,
    d: "M1503.05 455.303v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__el)",
    fillOpacity: 0.06,
    d: "M1503.05 455.303v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__em)",
    fillOpacity: 0.12,
    d: "M1292.27 455.303v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.301z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__en)",
    fillOpacity: 0.06,
    d: "M1292.27 455.303v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.301z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eo)",
    fillOpacity: 0.12,
    d: "M1207.98 455.303v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.301z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ep)",
    fillOpacity: 0.06,
    d: "M1207.98 455.303v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.301z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eq)",
    fillOpacity: 0.12,
    d: "M1355.33 419.528v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__er)",
    fillOpacity: 0.06,
    d: "M1355.33 419.528v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__es)",
    fillOpacity: 0.12,
    d: "M1186.69 419.528v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__et)",
    fillOpacity: 0.06,
    d: "M1186.69 419.528v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eu)",
    fillOpacity: 0.12,
    d: "M1144.55 419.528v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ev)",
    fillOpacity: 0.06,
    d: "M1144.55 419.528v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ew)",
    fillOpacity: 0.12,
    d: "M1376.16 598.924v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.301z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ex)",
    fillOpacity: 0.06,
    d: "M1376.16 598.924v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.301z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ey)",
    fillOpacity: 0.12,
    d: "M1249.69 598.925v-22.601l-19.77-11.3-19.78 11.3v22.601l19.78 11.3z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ez)",
    fillOpacity: 0.06,
    d: "M1249.69 598.925v-22.601l-19.77-11.3-19.78 11.3v22.601l19.78 11.3z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eA)",
    fillOpacity: 0.12,
    d: "M1376.52 383.253v-22.601l-19.78-11.3-19.77 11.3v22.601l19.77 11.3z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eB)",
    fillOpacity: 0.06,
    d: "M1376.52 383.253v-22.601l-19.78-11.3-19.77 11.3v22.601l19.77 11.3z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eC)",
    fillOpacity: 0.12,
    d: "M1250.07 383.253v-22.601l-19.78-11.3-19.77 11.3v22.601l19.77 11.3z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eD)",
    fillOpacity: 0.06,
    d: "M1250.07 383.253v-22.601l-19.78-11.3-19.77 11.3v22.601l19.77 11.3z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eE)",
    fillOpacity: 0.06,
    d: "M1439.62 563.036v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eF)",
    fillOpacity: 0.04,
    d: "M1439.62 563.036v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eG)",
    fillOpacity: 0.06,
    d: "M1397.48 563.036v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eH)",
    fillOpacity: 0.04,
    d: "M1397.48 563.036v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eI)",
    fillOpacity: 0.06,
    d: "M1355.33 563.036v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eJ)",
    fillOpacity: 0.04,
    d: "M1355.33 563.036v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eK)",
    fillOpacity: 0.06,
    d: "M1460.91 527.399v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eL)",
    fillOpacity: 0.04,
    d: "M1460.91 527.399v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eM)",
    fillOpacity: 0.06,
    d: "M1334.44 527.399v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eN)",
    fillOpacity: 0.04,
    d: "M1334.44 527.399v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eO)",
    fillOpacity: 0.06,
    d: "M1207.98 527.399v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eP)",
    fillOpacity: 0.04,
    d: "M1207.98 527.399v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eQ)",
    fillOpacity: 0.06,
    d: "M1165.8 527.399v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eR)",
    fillOpacity: 0.04,
    d: "M1165.8 527.399v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eS)",
    fillOpacity: 0.06,
    d: "M1271.01 491.325v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eT)",
    fillOpacity: 0.04,
    d: "M1271.01 491.325v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eU)",
    fillOpacity: 0.06,
    d: "M1228.87 491.325v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eV)",
    fillOpacity: 0.04,
    d: "M1228.87 491.325v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eW)",
    fillOpacity: 0.06,
    d: "M1186.69 491.325v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eX)",
    fillOpacity: 0.04,
    d: "M1186.69 491.325v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eY)",
    fillOpacity: 0.06,
    d: "M1397.11 635.2v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__eZ)",
    fillOpacity: 0.04,
    d: "M1397.11 635.2v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fa)",
    fillOpacity: 0.06,
    d: "M1354.97 635.2v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fb)",
    fillOpacity: 0.04,
    d: "M1354.97 635.2v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fc)",
    fillOpacity: 0.06,
    d: "M1312.79 635.2v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fd)",
    fillOpacity: 0.04,
    d: "M1312.79 635.2v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fe)",
    fillOpacity: 0.06,
    d: "M1439.62 419.528v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ff)",
    fillOpacity: 0.04,
    d: "M1439.62 419.528v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fg)",
    fillOpacity: 0.06,
    d: "M1397.48 419.528v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fh)",
    fillOpacity: 0.04,
    d: "M1397.48 419.528v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fi)",
    fillOpacity: 0.06,
    d: "M1313.16 419.528v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fj)",
    fillOpacity: 0.04,
    d: "M1313.16 419.528v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fk)",
    fillOpacity: 0.06,
    d: "M1460.46 598.924v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.301z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fl)",
    fillOpacity: 0.04,
    d: "M1460.46 598.924v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.301z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fm)",
    fillOpacity: 0.06,
    d: "M1418.31 598.924v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.301z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fn)",
    fillOpacity: 0.04,
    d: "M1418.31 598.924v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.301z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fo)",
    fillOpacity: 0.06,
    d: "M1291.84 598.924v-22.6l-19.78-11.3-19.77 11.3v22.601l19.77 11.3z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fp)",
    fillOpacity: 0.04,
    d: "M1291.84 598.924v-22.6l-19.78-11.3-19.77 11.3v22.601l19.77 11.3z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fq)",
    fillOpacity: 0.06,
    d: "M1292.21 383.253v-22.601l-19.78-11.3-19.77 11.3v22.601l19.77 11.3z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fr)",
    fillOpacity: 0.04,
    d: "M1292.21 383.253v-22.601l-19.78-11.3-19.77 11.3v22.601l19.77 11.3z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fs)",
    fillOpacity: 0.06,
    d: "M1207.91 383.253v-22.601l-19.78-11.3-19.77 11.3v22.601l19.77 11.3z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ft)",
    fillOpacity: 0.04,
    d: "M1207.91 383.253v-22.601l-19.78-11.3-19.77 11.3v22.601l19.77 11.3z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fu)",
    fillOpacity: 0.06,
    d: "M1165.75 383.253v-22.601l-19.78-11.3-19.77 11.3v22.601l19.77 11.3z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fv)",
    fillOpacity: 0.04,
    d: "M1165.75 383.253v-22.601l-19.78-11.3-19.77 11.3v22.601l19.77 11.3z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fw)",
    fillOpacity: 0.06,
    d: "M1481.76 347.9v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fx)",
    fillOpacity: 0.04,
    d: "M1481.76 347.9v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fy)",
    fillOpacity: 0.06,
    d: "M1439.62 347.9v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fz)",
    fillOpacity: 0.04,
    d: "M1439.62 347.9v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fA)",
    fillOpacity: 0.06,
    d: "M1523.94 563.036v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fB)",
    fillOpacity: 0.06,
    d: "M1481.8 563.036v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fC)",
    fillOpacity: 0.06,
    d: "M1313.16 563.036v-22.6l-19.78-11.301-19.77 11.301v22.6l19.77 11.3z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fD)",
    fillOpacity: 0.06,
    d: "M1271.01 563.036v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fE)",
    fillOpacity: 0.06,
    d: "M1228.87 563.036v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fF)",
    fillOpacity: 0.06,
    d: "M1186.69 563.036v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fG)",
    fillOpacity: 0.06,
    d: "M1144.55 563.036v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fH)",
    fillOpacity: 0.06,
    d: "M1503.05 527.399v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fI)",
    fillOpacity: 0.06,
    d: "M1418.74 527.399v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fJ)",
    fillOpacity: 0.06,
    d: "M1376.59 527.399v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fK)",
    fillOpacity: 0.06,
    d: "M1523.94 491.325v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fL)",
    fillOpacity: 0.06,
    d: "M1481.8 491.325v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fM)",
    fillOpacity: 0.06,
    d: "M1460.91 455.303v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.301z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fN)",
    fillOpacity: 0.06,
    d: "M1418.74 455.303v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.301z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fO)",
    fillOpacity: 0.06,
    d: "M1376.59 455.303v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.301z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fP)",
    fillOpacity: 0.06,
    d: "M1334.44 455.303v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fQ)",
    fillOpacity: 0.06,
    d: "M1250.12 455.303v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fR)",
    fillOpacity: 0.06,
    d: "M1165.8 455.303v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fS)",
    fillOpacity: 0.06,
    d: "M1481.43 635.2v-22.6l-19.78-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fT)",
    fillOpacity: 0.06,
    d: "M1439.26 635.2v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fU)",
    fillOpacity: 0.06,
    d: "M1270.65 635.2v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fV)",
    fillOpacity: 0.06,
    d: "M1228.5 635.2v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fW)",
    fillOpacity: 0.06,
    d: "M1186.33 635.2v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fX)",
    fillOpacity: 0.06,
    d: "M1523.94 419.528v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fY)",
    fillOpacity: 0.06,
    d: "M1481.8 419.528v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__fZ)",
    fillOpacity: 0.06,
    d: "M1271.01 419.528v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ga)",
    fillOpacity: 0.06,
    d: "M1228.87 419.528v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gb)",
    fillOpacity: 0.06,
    d: "M1502.62 598.924v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gc)",
    fillOpacity: 0.06,
    d: "M1333.99 598.924v-22.6l-19.78-11.3-19.77 11.3v22.601l19.77 11.3z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gd)",
    fillOpacity: 0.06,
    d: "M1207.55 598.925v-22.601l-19.77-11.3-19.78 11.3v22.601l19.78 11.3z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ge)",
    fillOpacity: 0.06,
    d: "M1165.37 598.925v-22.601l-19.77-11.3-19.78 11.3v22.601l19.78 11.3z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gf)",
    fillOpacity: 0.06,
    d: "M1502.99 383.253v-22.601l-19.78-11.3-19.77 11.3v22.601l19.77 11.3z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gg)",
    fillOpacity: 0.06,
    d: "M1460.82 383.253v-22.601l-19.77-11.3-19.78 11.3v22.601l19.78 11.3z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gh)",
    fillOpacity: 0.06,
    d: "M1418.68 383.253v-22.601l-19.78-11.3-19.78 11.3v22.601l19.78 11.3z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gi)",
    fillOpacity: 0.06,
    d: "M1334.36 383.253v-22.601l-19.77-11.3-19.78 11.3v22.601l19.78 11.3z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gj)",
    fillOpacity: 0.06,
    d: "M1397.48 491.325v-22.6l-19.78-11.301-19.77 11.301v22.6l19.77 11.3z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gk)",
    fillOpacity: 0.12,
    d: "M728.269 944.399v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gl)",
    fillOpacity: 0.06,
    d: "M728.269 944.399v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gm)",
    fillOpacity: 0.12,
    d: "M686.121 944.399v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.3z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gn)",
    fillOpacity: 0.06,
    d: "M686.121 944.399v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.3z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__go)",
    fillOpacity: 0.12,
    d: "M875.621 908.325v-22.6l-19.775-11.301-19.776 11.301v22.6l19.776 11.3z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gp)",
    fillOpacity: 0.06,
    d: "M875.621 908.325v-22.6l-19.775-11.301-19.776 11.301v22.6l19.776 11.3z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gq)",
    fillOpacity: 0.12,
    d: "M791.332 908.325v-22.6l-19.776-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gr)",
    fillOpacity: 0.06,
    d: "M791.332 908.325v-22.6l-19.776-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gs)",
    fillOpacity: 0.12,
    d: "M749.16 908.325v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.3z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gt)",
    fillOpacity: 0.06,
    d: "M749.16 908.325v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.3z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gu)",
    fillOpacity: 0.12,
    d: "M580.55 908.325v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gv)",
    fillOpacity: 0.06,
    d: "M580.55 908.325v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gw)",
    fillOpacity: 0.12,
    d: "M939.05 872.303v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.301z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gx)",
    fillOpacity: 0.06,
    d: "M939.05 872.303v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.301z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gy)",
    fillOpacity: 0.12,
    d: "M728.269 872.303v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.301z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gz)",
    fillOpacity: 0.06,
    d: "M728.269 872.303v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.301z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gA)",
    fillOpacity: 0.12,
    d: "M643.98 872.303v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.301z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gB)",
    fillOpacity: 0.06,
    d: "M643.98 872.303v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.301z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gC)",
    fillOpacity: 0.12,
    d: "M791.332 836.528v-22.6l-19.776-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gD)",
    fillOpacity: 0.06,
    d: "M791.332 836.528v-22.6l-19.776-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gE)",
    fillOpacity: 0.12,
    d: "M622.691 836.528v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gF)",
    fillOpacity: 0.06,
    d: "M622.691 836.528v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gG)",
    fillOpacity: 0.12,
    d: "M580.55 836.528v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gH)",
    fillOpacity: 0.06,
    d: "M580.55 836.528v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gI)",
    fillOpacity: 0.12,
    d: "M812.16 1015.92v-22.596l-19.775-11.3-19.776 11.3v22.596l19.776 11.3z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gJ)",
    fillOpacity: 0.06,
    d: "M812.16 1015.92v-22.596l-19.775-11.3-19.776 11.3v22.596l19.776 11.3z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gK)",
    fillOpacity: 0.12,
    d: "M685.691 1015.92v-22.596l-19.775-11.3-19.775 11.3v22.596l19.775 11.3z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gL)",
    fillOpacity: 0.06,
    d: "M685.691 1015.92v-22.596l-19.775-11.3-19.775 11.3v22.596l19.775 11.3z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gM)",
    fillOpacity: 0.12,
    d: "M812.519 800.253v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gN)",
    fillOpacity: 0.06,
    d: "M812.519 800.253v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gO)",
    fillOpacity: 0.12,
    d: "M686.066 800.253v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gP)",
    fillOpacity: 0.06,
    d: "M686.066 800.253v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gQ)",
    fillOpacity: 0.06,
    d: "M875.621 980.036v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gR)",
    fillOpacity: 0.06,
    d: "M833.481 980.036v-22.6l-19.776-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gS)",
    fillOpacity: 0.06,
    d: "M791.332 980.036v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gT)",
    fillOpacity: 0.06,
    d: "M896.91 944.399v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gU)",
    fillOpacity: 0.06,
    d: "M770.441 944.399v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gV)",
    fillOpacity: 0.06,
    d: "M643.98 944.399v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gW)",
    fillOpacity: 0.06,
    d: "M601.801 944.399v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.3z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gX)",
    fillOpacity: 0.06,
    d: "M707.012 908.325v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.3z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gY)",
    fillOpacity: 0.06,
    d: "M664.871 908.325v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__gZ)",
    fillOpacity: 0.06,
    d: "M622.691 908.325v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ha)",
    fillOpacity: 0.06,
    d: "M833.113 1052.2v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hb)",
    fillOpacity: 0.06,
    d: "M790.973 1052.2v-22.6l-19.776-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hc)",
    fillOpacity: 0.06,
    d: "M748.793 1052.2v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hd)",
    fillOpacity: 0.06,
    d: "M875.621 836.528v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__he)",
    fillOpacity: 0.06,
    d: "M833.481 836.528v-22.6l-19.776-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hf)",
    fillOpacity: 0.06,
    d: "M749.16 836.528v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hg)",
    fillOpacity: 0.06,
    d: "M896.457 1015.92v-22.596l-19.775-11.3-19.775 11.3v22.596l19.775 11.3z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hh)",
    fillOpacity: 0.06,
    d: "M854.309 1015.92v-22.596l-19.776-11.3-19.775 11.3v22.596l19.775 11.3z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hi)",
    fillOpacity: 0.06,
    d: "M727.84 1015.92v-22.596l-19.775-11.3-19.776 11.3v22.596l19.776 11.3z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hj)",
    fillOpacity: 0.06,
    d: "M728.207 800.253v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hk)",
    fillOpacity: 0.06,
    d: "M643.91 800.253v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hl)",
    fillOpacity: 0.06,
    d: "M601.746 800.253v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hm)",
    fillOpacity: 0.06,
    d: "M917.761 764.9v-22.6L897.986 731l-19.775 11.3v22.6l19.775 11.301z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hn)",
    fillOpacity: 0.06,
    d: "M875.62 764.9v-22.6L855.845 731l-19.775 11.3v22.6l19.775 11.301z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ho)",
    fillOpacity: 0.06,
    d: "M959.941 980.036v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hp)",
    fillOpacity: 0.06,
    d: "M917.8 980.036v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hq)",
    fillOpacity: 0.06,
    d: "M749.16 980.036v-22.6l-19.775-11.301-19.776 11.301v22.6l19.776 11.3z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hr)",
    fillOpacity: 0.06,
    d: "M707.011 980.036v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hs)",
    fillOpacity: 0.06,
    d: "M664.871 980.036v-22.6l-19.775-11.301-19.776 11.301v22.6l19.776 11.3z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__ht)",
    fillOpacity: 0.06,
    d: "M622.691 980.036v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hu)",
    fillOpacity: 0.06,
    d: "M580.55 980.036v-22.6l-19.775-11.301L541 957.436v22.6l19.775 11.3z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hv)",
    fillOpacity: 0.06,
    d: "M939.05 944.399v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hw)",
    fillOpacity: 0.06,
    d: "M854.738 944.399v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hx)",
    fillOpacity: 0.06,
    d: "M812.59 944.399v-22.6l-19.776-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hy)",
    fillOpacity: 0.06,
    d: "M959.941 908.325v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hz)",
    fillOpacity: 0.06,
    d: "M917.8 908.325v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hA)",
    fillOpacity: 0.06,
    d: "M896.91 872.303v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.301z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hB)",
    fillOpacity: 0.06,
    d: "M854.738 872.303v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.301z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hC)",
    fillOpacity: 0.06,
    d: "M812.59 872.303v-22.6l-19.776-11.3-19.775 11.3v22.6l19.775 11.301z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hD)",
    fillOpacity: 0.06,
    d: "M770.441 872.303v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.301z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hE)",
    fillOpacity: 0.06,
    d: "M686.121 872.303v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.301z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hF)",
    fillOpacity: 0.06,
    d: "M601.8 872.303v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.301z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hG)",
    fillOpacity: 0.06,
    d: "M917.425 1052.2v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hH)",
    fillOpacity: 0.06,
    d: "M875.261 1052.2v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hI)",
    fillOpacity: 0.06,
    d: "M706.652 1052.2v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hJ)",
    fillOpacity: 0.06,
    d: "M664.504 1052.2v-22.6l-19.776-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hK)",
    fillOpacity: 0.06,
    d: "M622.332 1052.2v-22.6l-19.776-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hL)",
    fillOpacity: 0.06,
    d: "M959.941 836.528v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hM)",
    fillOpacity: 0.06,
    d: "M917.8 836.528v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hN)",
    fillOpacity: 0.06,
    d: "M707.011 836.528v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hO)",
    fillOpacity: 0.06,
    d: "M664.871 836.528v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.3z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hP)",
    fillOpacity: 0.06,
    d: "M938.621 1015.92v-22.596l-19.775-11.3-19.776 11.3v22.596l19.776 11.3z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hQ)",
    fillOpacity: 0.06,
    d: "M769.988 1015.92v-22.596l-19.775-11.3-19.775 11.3v22.596l19.775 11.3z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hR)",
    fillOpacity: 0.06,
    d: "M643.55 1015.92v-22.596l-19.775-11.3-19.775 11.3v22.596l19.775 11.3z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hS)",
    fillOpacity: 0.06,
    d: "M601.371 1015.92v-22.596l-19.775-11.3-19.776 11.3v22.596l19.776 11.3z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hT)",
    fillOpacity: 0.06,
    d: "M938.988 800.253v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hU)",
    fillOpacity: 0.06,
    d: "M896.824 800.253v-22.601l-19.775-11.3-19.776 11.3v22.601l19.776 11.3z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hV)",
    fillOpacity: 0.06,
    d: "M854.675 800.253v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hW)",
    fillOpacity: 0.06,
    d: "M770.363 800.253v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home-bg_svg__hX)",
    fillOpacity: 0.06,
    d: "M833.48 908.325v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "#171A2B",
    d: "M1014.24 107.519v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__hY)",
    strokeLinecap: "round",
    strokeOpacity: 0.22,
    d: "m1034.01 140.843-19.27-11.014v-22.02l19.27-11.014 19.28 11.014v22.02z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__hZ)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m1034.01 140.843-19.27-11.014v-22.02l19.27-11.014 19.28 11.014v22.02z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "#161826",
    d: "M1035.2 143.107v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__ia)",
    strokeLinecap: "round",
    strokeOpacity: 0.43,
    d: "m1054.97 176.431-19.27-11.014v-22.02l19.27-11.014 19.28 11.014v22.02z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__ib)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m1054.97 176.431-19.27-11.014v-22.02l19.27-11.014 19.28 11.014v22.02z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E1019",
    d: "M406.5 425.3v22.6l19.775 11.301L446.05 447.9v-22.6L426.275 414z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__ic)",
    strokeLinecap: "round",
    strokeOpacity: 0.28,
    d: "M426.275 458.625 407 447.61v-22.02l19.275-11.014 19.275 11.014v22.02z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__id)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "M426.275 458.625 407 447.61v-22.02l19.275-11.014 19.275 11.014v22.02z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "#10121C",
    d: "M427.5 461.3v22.6l19.775 11.301L467.05 483.9v-22.6L447.275 450z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__ie)",
    strokeLinecap: "round",
    strokeOpacity: 0.65,
    d: "M447.275 494.625 428 483.61v-22.02l19.275-11.014 19.275 11.014v22.02z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__if)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "M447.275 494.625 428 483.61v-22.02l19.275-11.014 19.275 11.014v22.02z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__ig)",
    strokeOpacity: 0.68,
    d: "M405 425.5V448l21.5 12.5m0 0V484L405 495.5m21.5-35 19-11"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D0F18",
    d: "M1316.6 468.954v22.601l19.78 11.3 19.77-11.3v-22.601l-19.77-11.3z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__ih)",
    strokeLinecap: "round",
    strokeOpacity: 0.37,
    d: "m1336.38 502.279-19.28-11.014v-22.02l19.28-11.015 19.27 11.015v22.02z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__ii)",
    strokeLinecap: "round",
    strokeOpacity: 0.5,
    d: "m1336.38 502.279-19.28-11.014v-22.02l19.28-11.015 19.27 11.015v22.02z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0D15",
    d: "m1357.71 466.382-19.27-11.014v-22.02l19.27-11.014 19.28 11.014v22.02z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__ij)",
    strokeLinecap: "round",
    strokeOpacity: 0.37,
    d: "m1357.71 466.382-19.27-11.014v-22.02l19.27-11.014 19.28 11.014v22.02z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__ik)",
    strokeLinecap: "round",
    d: "m1357.71 466.382-19.27-11.014v-22.02l19.27-11.014 19.28 11.014v22.02z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D0E17",
    d: "M1274.42 468.972v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__il)",
    strokeLinecap: "round",
    strokeOpacity: 0.16,
    d: "m1294.19 502.297-19.27-11.015v-22.02l19.27-11.014 19.28 11.014v22.02z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__im)",
    strokeLinecap: "round",
    strokeOpacity: 0.5,
    d: "m1294.19 502.297-19.27-11.015v-22.02l19.27-11.014 19.28 11.014v22.02z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0C14",
    d: "M1337.5 504.636v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__in)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "M1357.27 537.961 1338 526.946v-22.02l19.27-11.014 19.28 11.014v22.02z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__io)",
    d: "m1274.12 493.036 19.88 11.686 21.16-12.484m0 0 20.95 11.851m-20.95-11.851-.03-21.954m20.98 33.805v24.367m0-24.367 21.41-12.016v-23.579l20.89-12.353"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__ip)",
    d: "m511.871 269.773 19.881 11.685 21.155-12.484m0 0 20.954 11.852m-20.954-11.852-.026-21.954m20.98 33.806v24.366m0-24.366 20.248-11.852"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "#10121E",
    d: "M554.246 245.37v22.601l19.775 11.3 19.775-11.3V245.37l-19.775-11.3z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__iq)",
    strokeLinecap: "round",
    strokeOpacity: 0.66,
    d: "m574.021 278.695-19.275-11.014v-22.02l19.275-11.015 19.275 11.015v22.02z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__ir)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m574.021 278.695-19.275-11.014v-22.02l19.275-11.015 19.275 11.015v22.02z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "#10131E",
    d: "M512 245.495v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__is)",
    strokeLinecap: "round",
    strokeOpacity: 0.44,
    d: "M531.775 278.82 512.5 267.806v-22.02l19.275-11.015 19.275 11.015v22.02z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__it)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "M531.775 278.82 512.5 267.806v-22.02l19.275-11.015 19.275 11.015v22.02z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "#11131F",
    d: "m595.021 314.695-19.275-11.014v-22.02l19.275-11.015 19.275 11.015v22.02z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__iu)",
    strokeLinecap: "round",
    d: "m595.021 314.695-19.275-11.014v-22.02l19.275-11.015 19.275 11.015v22.02z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__iv)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m595.021 314.695-19.275-11.014v-22.02l19.275-11.015 19.275 11.015v22.02z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0B1315",
    d: "M668.289 957.068v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__iw)",
    strokeLinecap: "round",
    strokeOpacity: 0.23,
    d: "m688.064 990.392-19.275-11.014v-22.02l19.275-11.015 19.275 11.015v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__ix)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m688.064 990.392-19.275-11.014v-22.02l19.275-11.015 19.275 11.015v22.02z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#091012",
    d: "M626.16 957.058v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__iy)",
    strokeLinecap: "round",
    strokeOpacity: 0.23,
    d: "m645.935 990.382-19.275-11.014v-22.02l19.275-11.014 19.275 11.014v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__iz)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m645.935 990.382-19.275-11.014v-22.02l19.275-11.014 19.275 11.014v22.02z"
  }))), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__iA)",
    d: "m898.109 847.255-19.881-11.686-21.155 12.484m0 0-20.954-11.851m20.954 11.851.026 21.954m-20.98-33.805v-24.367m0 24.367-20.247 11.851"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C1415",
    d: "M855.734 871.657v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__iB)",
    strokeLinecap: "round",
    strokeOpacity: 0.31,
    d: "m835.959 838.332 19.275 11.015v22.02l-19.275 11.014-19.275-11.014v-22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__iC)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m835.959 838.332 19.275 11.015v22.02l-19.275 11.014-19.275-11.014v-22.02z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A1113",
    d: "M897.98 871.532v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__iD)",
    strokeLinecap: "round",
    strokeOpacity: 0.13,
    d: "m878.205 838.207 19.275 11.015v22.02l-19.275 11.014-19.275-11.014v-22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__iE)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m878.205 838.207 19.275 11.015v22.02l-19.275 11.014-19.275-11.014v-22.02z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0E1718",
    d: "M834.734 835.657v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__iF)",
    strokeLinecap: "round",
    strokeOpacity: 0.13,
    d: "m814.959 802.332 19.275 11.015v22.02l-19.275 11.014-19.275-11.014v-22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#home-bg_svg__iG)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m814.959 802.332 19.275 11.015v22.02l-19.275 11.014-19.275-11.014v-22.02z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-432.49724 -423.50302 1003.35843 -1024.66744 960 182.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#383D58",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#383D58",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#383D58",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#040406",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-138.148 543.535 287.614)scale(675.953 427.457)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#214E43",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#214E43",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#151721",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#08090C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__x",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__B",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__D",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__F",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__H",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 596 334.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__I",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__J",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__K",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__L",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__M",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__N",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__O",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__P",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__Q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__R",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__S",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__T",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__U",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__V",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__W",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__X",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__Y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__Z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ab",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ac",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ad",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ae",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__af",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 362 459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ag",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ah",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ai",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ak",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__al",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__am",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__an",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ao",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ap",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ar",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__as",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__at",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__au",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__av",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ax",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ay",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__az",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__aZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ba",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__be",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bi",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bk",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bo",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__br",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bs",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bt",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__by",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.054 -570.202 861.257)scale(152.684 159.549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.4998 64.49975 -67.39983 83.07432 520 317.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#2C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#2C2F45",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5C71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__bZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-84.9995 88.5005 -135.03777 -129.69578 1055 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ch",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ci",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ck",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__co",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cs",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ct",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(107.5003 -12.00002 13.5171 121.0909 821 251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__cZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__da",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__db",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__de",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__df",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__di",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dk",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__do",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ds",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dt",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__du",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.11 -28.247 1595.03)scale(145.803 125.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DAE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#21284B",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(130 35.50009 -13.75139 50.35706 1058 138.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#333A5D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__dZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ea",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ec",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ed",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ee",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ef",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ei",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ej",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ek",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__el",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__em",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__en",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eo",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ep",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__er",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__es",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__et",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ev",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ew",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ex",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ey",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ez",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.405 350.704 948.506)scale(123.086 187.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B313F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2B313F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B313F",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(190.5 0 0 147.433 1427 453.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__eZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fe",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ff",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fi",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fk",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fo",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fs",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ft",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-107.5004 11.99921 -13.5162 -121.091 1463.94 420.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.619 -1028.553 4533.55)scale(110.813 85.8691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__fZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ga",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ge",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gi",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(42.075 66.9 1995.601)scale(145.5 113.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#333A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#333A5D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333A5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gk",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__go",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gs",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gt",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-66.303 1093.93 -23.727)scale(120.675 184.131)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#1D2E2E",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(91.50006 57.00009 -26.4097 42.39447 776 830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__gZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ha",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__he",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hi",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hk",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(75.0002 125.00012 -140.80285 84.48185 858.5 816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ho",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hs",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ht",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(94 22.49992 -20.21103 84.43752 833 887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#1D2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-15.92 982.336 -3584.994)scale(35.5427 39.8078)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__hZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-37.61474 21.86419 -24.48788 -42.1285 1060.07 110.085)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ia",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(36.46659 -15.20878 17.03387 40.84265 1035.2 159.321)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ib",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(134.108 517.094 291.578)scale(61.7043 69.1089)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ic",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-43.00007 7.99987 -8.95985 -48.16003 466 426.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__id",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(48.5 -10 11.2 54.31998 380 449.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ie",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(136.005 150.79 312.747)scale(40.3113 45.1486)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__if",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(48.5 -10 11.2 54.31998 401 485.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ih",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.61475 22.0619 -24.70932 9.64852 1324.49 456.092)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ii",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-133.011 785.167 -44.651)scale(21.7019 24.3062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ij",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(27.634 -207.45 2915.983)scale(28.8832 32.3492)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ik",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-133.011 788.03 -67.235)scale(21.7019 24.3062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__il",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.4532 50.98026 -57.09783 8.34759 1291.99 442.378)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__im",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-19.12505 -22.40997 25.09919 -21.42007 1315.54 505.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__in",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(33.22044 -10.59644 11.86803 37.20695 1326.28 529.432)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__iq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-43.00007 7.99987 -8.95985 -48.16003 613.746 246.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ir",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(48.5 -10 11.2 54.31998 527.746 269.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__is",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-32.58491 26.03455 -29.1587 -36.49511 564.36 228.487)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__it",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(48.5 -10 11.2 54.31998 485.5 269.695)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__iu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-56.04075 15.48356 -17.3416 -62.76569 644.118 270.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__iv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(48.5 -10 11.2 54.31998 548.746 305.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__iw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(135.192 169.92 611.367)scale(64.4448 72.1782)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABFFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABFFEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__ix",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(48.5 -10 11.2 54.31998 641.789 981.268)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__iy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-27.62138 36.50082 -40.88086 -30.9359 679.195 925.357)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABFFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABFFEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__iz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(48.5 -10 11.2 54.31998 599.66 981.258)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__iB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-40.876 1602.02 -614.016)scale(68.9336 77.2056)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABFFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABFFEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__iC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(168.35 397.89 468.73)scale(49.5202 55.4626)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__iD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(45.72149 -45.41671 50.86674 51.20808 844.946 903.233)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABFFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABFFEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__iE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(168.35 419.019 470.822)scale(49.5202 55.4626)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__iF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-64.516 1087.38 -196.369)scale(72.2599 80.9311)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABFFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABFFEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "home-bg_svg__iG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(168.35 389.226 449.659)scale(49.5202 55.4626)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__c",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__e",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__g",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__i",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__k",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__m",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__o",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__q",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__s",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__u",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__w",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__y",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__A",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__C",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__E",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__G",
    x1: 379.5,
    x2: 484.5,
    y1: 456,
    y2: 578.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__bA",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__bC",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__bE",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__bG",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__bI",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__bK",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__bM",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__bO",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__bQ",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__bS",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__bU",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__bW",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__bY",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__ca",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__cc",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__ce",
    x1: 838.5,
    x2: 943.5,
    y1: 248,
    y2: 370.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171B37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__ig",
    x1: 430.5,
    x2: 401.494,
    y1: 441.5,
    y2: 494.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0C0C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__io",
    x1: 1300.7,
    x2: 1332.43,
    y1: 479.274,
    y2: 531.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0C0C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__ip",
    x1: 538.45,
    x2: 570.177,
    y1: 256.01,
    y2: 307.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0C0C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-bg_svg__iA",
    x1: 871.53,
    x2: 839.803,
    y1: 861.017,
    y2: 809.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0C0C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg);
export default __webpack_public_path__ + "static/media/footer-bg.c77ca03d88cb34176c8c05311f06b8f9.svg";
export { ForwardRef as ReactComponent };